<template>
  <div v-if="rounds.length">
    <div class="content">
      <template v-if="voteSent">
        <h1 class="title" style="color: #faf9f6">Bijna klaar...</h1>

        <div class="card">
          <div class="html">
            <p>
              <strong class="text--accent">Check je mailbox</strong> voor een bevestigingsmail en klik daarin
              op de link om jouw stem definitief te maken. Doe je dat niet, dan kunnen we jouw stem helaas
              niet meetellen.
            </p>
            <p>
              <strong>Geen mail ontvangen? Kijk dan even in je spam folder.</strong>
            </p>
          </div>
        </div>

        <div class="html html--centered">
          <a href="/" class="button"> Naar de homepage </a>
        </div>
      </template>

      <template v-else>
        <h1 class="title" style="color: #faf9f6; text-decoration: underline">Inzenden</h1>

        <selection />

        <form class="form" @submit.prevent="submit" v-if="anySelected">
          <div class="form__field">
            <input
              style="background-color: #121212; color: #faf9f6; border: solid 1px #f2ad07"
              type="email"
              required
              class="form__input"
              ref="emailInput"
              placeholder="E-mailadres *"
              v-model="email"
              :disabled="sending"
              id="form__field_email"
            />
            <p v-if="hasInvalidEmail" class="text--error">Vul een geldig e-mailadres in</p>
          </div>
          <div class="form__checkbox">
            <input
              type="checkbox"
              required
              id="form__field_conditions"
              v-model="agreed"
              :disabled="sending"
            />
            <label class="form__label" for="form__field_conditions" style="color: #faf9f6">
              Ik ga akkoord met de
              <a
                class="link-hover"
                target="_blank"
                href="https://www.dutchrealityawards.nl/algemene-voorwaarden"
                @click.prevent="viewTerms = true"
              >
                voorwaarden
              </a>
            </label>
            <p v-if="didNotAgree" class="text--error">U moet nog akkoord gaan met voorwaarden</p>
          </div>
          <div class="form__field">
            <invisible-recaptcha
              :sitekey="captchaSiteKey"
              :validate="validate"
              :callback="submit"
              class="button button--fullwidth"
              style="background-color: #d9a22e"
              type="submit"
              :disabled="sending || isIncomplete()"
            >
              Inzenden
            </invisible-recaptcha>
          </div>

          <div style="color: #faf9f6">
           <small style="color: #faf9f6">
              Velden met een * zijn verplicht. Het is mogelijk om vaker te stemmen per e-mailadres, maar de
              reeds uitgebrachte stem wordt dan automatisch overschreven door de nieuwe stem.
            </small>            
            <br>
            <br>
            <p>Reality-tv leeft als nooit tevoren in Nederland. Met een keur aan spraakmakende programma’s, kleurrijke kandidaten en onvergetelijke tv-momenten, is het tijd om de sterren van het genre te eren. Je mag zelf bepalen wie dit jaar kans moet maken op de felbegeerde Dutch Reality Award. Je kunt je favoriet nu doorgeven. Mocht je nog niet weten op wie/wat je wilt stemmen – is stemmen hier correct? Want je kunt nog niet stemmen he? Misschien oplossen met: kun je nog wat inspiratie gebruiken? Hieronder een aantal talenten, hoogtepunten en programma’s!  Laat ons je dan hieronder inspireren. </p>
            <br>
            <p>De strijd om de titel Reality King is ongekend spannend. Wie mag zich straks dé Reality King van Nederland noemen? Wie is jouw favoriet? Geef het hierboven door.</p>

            <ul style="padding-inline: 32px;">
              <li>Chicco uit Oh oh Den Haag</li>
              <li>Diederik uit De Bondgenoten</li>
              <li>Faisel uit onder meer House of Villains, Hakken over de Sloot en Good Luck Guys</li>
              <li>Frans Bauer</li>
              <li>Gerard Joling</li>
              <li>Henk van Ex On The Beach</li>
              <li>Jay Lopez uit Een Huis Vol</li>
              <li>Jay Zwarts uit Temptation Island en Good Luck Guys</li>
              <li>Lil Kleine</li>
              <li>Maarten Blom uit Een Huis Vol</li>
              <li>Marco Verstappen uit Beauty and the Geek en Good Luck Guys</li>
              <li>Mart uit Wakker in Paraguay</li>
              <li>Martien Meiland</li>
              <li>Nick van Ex On The Beach</li>
              <li>Oos Keskbeke uit De Augurkenkoning</li>
              <li>René Bogaart uit De Bogaartjes</li>
              <li>Roland uit De Bondgenoten</li>
              <li>Ron Hauser uit Oh oh Den Haag</li>
              <li>Timothy uit B&amp;B</li>
              <li>Tobias Camman uit Het Perfecte Plaatje Op Reis in Vietnam</li>
              <li>Tom de Koning van Ticket to the Tribes</li>
              <li>Wout Tielemans uit Dropout Resort</li>
            </ul>

            <br>
            <p>Bij de dames is het minstens zo spannend. Zij strijden o.a. om de titel Reality Queen, maar kunnen natuurlijk ook kans maken als onderdeel van jouw favoriete programma of Reality Hoogtepunt! . Wie steelt dit jaar de show? Wie is jouw favoriet? Geef het hierboven door.
            </p>
            <p>
            <ul style="padding-inline: 32px;">
              <li>Anouk uit De Bondgenoten</li>
              <li>Caroline uit B&amp;B</li>
              <li>Charlotte Fix van Ex On The Beach: Double Dutch en Paradise Hotel</li>
              <li>Corrina Kouwen</li>
              <li>de Urker tweeling (Gerda en Mathilde) uit Echte Meisjes in de Jungle: Familie Editie</li>
              <li>Deborah van Lingen uit Hakken over de Sloot</li>
              <li>Demi van Ex On The Beach: Double Dutch</li>
              <li>Djamila Celine van The Real Housewives of Amsterdam</li>
              <li>Erica Renkema</li>
              <li>Harleya la Reine uit Hakken over de Sloot en Good Luck Guys</li>
              <li>Joke uit Oh oh Den Haag</li>
              <li>Josée Bronk van Schiphol Airport</li>
              <li>Kenzy uit Dames in de Dop</li>
              <li>Lisa uit Good Luck Guys</li>
              <li>Louisa Janssen uit Echte Meisjes</li>
              <li>Malindy Scheerhoorn uit Grote Gezinnen, Grote Vakanties</li>
              <li>Marijn Kuipers</li>
              <li>Mariska Bauer</li>
              <li>Marjan Strijbosch van The Real Housewives van het Zuiden</li>
              <li>Maxime Meiland</li>
              <li>Michella Kox uit A.S.S./House of Villains</li>
              <li>Monique Hansler uit De Hanslers</li>
              <li>Patty Brard uit A Beautiful Mess</li>
              <li>Sabrina Verhoef uit Grote Gezinnen, Grote Vakanties</li>
              <li>Sandra Bogaart van De Bogaartjes</li>
            </ul>
            </p>
            <br>

            <p>Vers bloed zorgt voor nieuwe energie in de Nederlandse reality wereld. …kunnen allemaal kans maken op dé doorbraak van het jaar. Elk van hen wist het afgelopen jaar het publiek te verrassen en jij bepaalt jouw favoriet. Heb je een andere keuze? Dat kan ook. Vult het hierboven in!</p>            
            <ul style="padding-inline: 32px;">
              <li>Caroline uit B&amp;B</li>
              <li>De familie Bal uit Een Huis Vol</li>
              <li>De familie Bogaart van De Bogaartjes</li>
              <li>Domenik Romano uit Married at First Sight</li>
              <li>Harleya la Reine uit Hakken over de Sloot</li>
              <li>Kim Weber uit Echte Reizigers Vrouwen</li>
              <li>Leslie de Ruiter uit Million Dollar Listing</li>
              <li>Lilian Dziedzic van The Real Housewives of Amsterdam</li>
              <li>Luca Diez uit Hakken over de Sloot S2</li>
              <li>Margretha uit De verloskundigen</li>
              <li>Maurice uit Rutger en de uitkeringstrekkers op vakantie</li>
              <li>Mitchell van Genechten uit Good Luck Guys</li>
              <li>Nino van der Meijde uit Andy &amp; Melisa</li>
              <li>Nova Jansen uit Dropout Resort</li>
              <li>Rian Donders van Ticket to the Tribes</li>
              <li>Ron Hauser uit Oh oh Den Haag</li>
              <li>Timothy uit B&amp;B Vol Liefde</li>
              <li>Tom de Koning van Ticket to the Tribes</li>
            </ul>
            <br>
            <p>Het afgelopen jaar leverde weer talloze legendarische reality momenten op. 
            Elk moment bracht gespreksstof en spektakel in de huiskamer. Welk moment is jouw favoriet? Geef het hierboven door.</p>
            <br>

            <p>Dit jaar hebben we wederom drie categorieën voor Beste Reality Programma. Namelijk Love/ Dating, Survival/Adventure/Competitie en Real Life.</p> 
            <p>Hieronder een kort overzicht van de eventuele programma’s die kans maken. Dit is een inspiratielijst. Er zijn er zeker nog veel meer maar die je zelf mag invullen en bepalen:</p>
            <br>
            <p>Het gaat bij de Dutch Reality Awards om Nederlandse realitysterren/realityprogramma’s/momenten/doorbraak die tussen 1 december 2025 en 20 oktober 2026 op televisie of streamingdiensten te zien zijn.</p>
            <br>

            <ul style="padding-inline: 32px;">
              <li>Arie die zijn tanden heeft laten bleken en daarmee het hart van Caroline heeft veroverd in B&amp;B</li>
              <li>Bakje kwark in het zwembad van Charlotte en Levinio bij Ex On The Beach: Double Dutch</li>
              <li>de allereerste ‘nee’ in Married at First Sight</li>
              <li>de beschuldiging van Roland aan het adres van Salar in De Bondgenoten</li>
              <li>de eerste mannenseks in Ex on the Beach</li>
              <li>De gehele reünie van B&amp;B Vol Liefde 2026</li>
              <li>de hernieuwde vriendschap tussen Louisa en Michella</li>
              <li>de onthulling rond het dubbelleven van Marijn Kuipers</li>
              <li>de opvallende ‘Andrew Tate’ van First Dates</li>
              <li>de ruzie tussen Megan en Shani in A.S.S.</li>
              <li>de spraakmakende ontmoeting van Jay en Lisa in Good Luck Guys</li>
              <li>Demi die per ongeluk Charlotte aanvalt ipv Charlene middenin de nacht ’nee jij ja, ja jij ja, ja jij ja’ uit Ex On The Beach: Double Dutch</li>
              <li>Etiquette koning Tom geeft zijn horloge aan een Himba-lid uit Ticket to the Tribes</li>
              <li>het extreem strenge vriendje Ruben in Undercover Lover</li>
              <li>het telefoongesprek tussen Anouk en Max</li>
              <li>het uienincident van de Hanslers</li>
              <li>Joke struint over de Haagse Markt in Oh oh Den Haag</li>
              <li>Maarten &amp; Gerdine Blom gaan naar de Apenheul, raken continu kinderen kwijt bij Een Huis Vol</li>
              <li>Maarten &amp; Gerdine Blom gaan trampoline in hun tuin plaatsen, uit Een Huis Vol</li>
              <li>Michael die tijdens de reünie van B&amp;B in tranen uitbreekt, omdat eindelijk de wereld mag weten dat hij samen met Timothy is geëindigd bij B&amp;B</li>
              <li>Nick en Marla die op de laatste avond abrupt EOTBDD verlaten over beelden van een zoen van Nick met Jennifer (Ex On The Beach: Double Dutch)</li>
              <li>Rene verrast Sandra met 2 alpaca’s bij De Bogaartjes</li>
              <li>Rijk reageert op Ray’s comment over de taak van een vrouw in Temptation Island</li>
              <li>Maxime gooit alle remmen los de eerste avond in Undercover Lover en stort zich op zijn vrouwelijke naamgenoot in Undercover Lover</li>
              <li>Tenen likken in het zwembad van Terror Jaap en Malgosia in House of Villains</li>
            </ul>
            <br>

            <p>Realityprogramma’s: Real Life, Survival/Adventure/Competitie en Love/Dating</p>
            <p>In de categorie Real Life:</p>

            <ul style="padding-inline: 32px;">
              <li>010: De mensen die Rotterdam Kleur Geven</li>
              <li>4 Handen op 1 Buik</li>
              <li>A.S.S. – Anti Survival Show</li>
              <li>Andy &amp; Melisa</li>
              <li>Bauers</li>
              <li>Bij ons op de Wallen</li>
              <li>Brandweer010</li>
              <li>Daar Gaan Ze Weer</li>
              <li>De Augurkenkoning</li>
              <li>De Bevers</li>
              <li>De Bogaartjes</li>
              <li>De Bondgenoten</li>
              <li>De Hanslers</li>
              <li>De Roelvinkjes</li>
              <li>Dropout Resort</li>
              <li>Echte Gooische Moeders</li>
              <li>Echte Reizigers Vrouwen</li>
              <li>Een Huis Vol</li>
              <li>Oh oh Den Haag</li>
              <li>Only Joling</li>
              <li>Rutger en de uitkeringstrekkers op vakantie</li>
              <li>Schiphol Airport</li>
              <li>The Real Housewives of Amsterdam</li>
              <li>The Real Housewives van het Zuiden</li>
            </ul>
            <br>
            <p>In de categorie Survival/Adventure/Competitie</p>
            <ul style="padding-inline: 32px;">
              <li>De Slechtste Chauffeur van Nederland</li>
              <li>De Verraders</li>
              <li>Dropout Resort</li>
              <li>Echte Jongens op Safari</li>
              <li>Echte Meisjes in de Jungle: Familie Editie</li>
              <li>Expeditie Robinson</li>
              <li>Football Island</li>
              <li>Good Luck Guys</li>
              <li>Hakken over de Sloot</li>
              <li>Het Perfecte Plaatje Op Reis in Vietnam</li>
              <li>House of Villains</li>
              <li>Jachtseizoen: Most Wanted</li>
              <li>NPO Start-editie van Wie is de Mol?</li>
              <li>Pandora</li>
              <li>So You Think You Can Dance</li>
              <li>Ticket to the Tribes</li>
              <li>Watch Your Back</li>
              <li>Wolven</li>
            </ul>
            <br>

            <p>In de categorie Love/Dating</p>
            <ul style="padding-inline: 32px;">
              <li>B&amp;B Vol Liefde</li>
              <li>Beauty and the Geek</li>
              <li>Boer Zoekt Vrouw</li>
              <li>Daten in het dorp op Texel</li>
              <li>De Bachelorette</li>
              <li>Ex On The Beach: Double Dutch</li>
              <li>First Dates</li>
              <li>Married at First Sight</li>
              <li>Onderweg naar liefde</li>
              <li>Paradise Hotel</li>
              <li>Temptation Island</li>
              <li>Undercover Lover</li>
              <li>Winter Vol Liefde</li>
            </ul>
          </div>
          <div>
        </div>
        </form>
        <p class="p--md" style="color: #faf9f6" v-else>
          <router-link :to="{ name: 'home' }">Selecteer</router-link>
          eerst een of meer genomineerden.
        </p>
      </template>
    </div>

    <div
      class="overlay"
      v-show="viewTerms"
      :class="{ 'overlay--visible': viewTerms }"
      @click.self="viewTerms = false"
    >
      <div class="modal">
        <div class="modal__head">
          <h2>Voorwaarden</h2>
          <button type="button" @click="viewTerms = false">Sluiten</button>
        </div>
        <div class="modal__body">
          <p>Er zijn geen algemene voorwaarden ingevuld.</p>
        </div>
      </div>
    </div>
  </div>
  <p v-else class="p--md">Er kan momenteel niet gestemd worden.</p>
</template>

<script>
import { post } from '@/util/request'
import InvisibleRecaptcha from 'vue-invisible-recaptcha'
import Selection from '@/components/Selection'

const captchaSiteKey = process.env.CAPTCHA_KEY

export default {
  name: 'Submit',

  components: {
    'invisible-recaptcha': InvisibleRecaptcha,
    selection: Selection
  },

  data() {
    return {
      email: '',
      agreed: false,
      keepUpToDate: true,
      galaOptIn: false,
      phone: '',
      sending: false,
      voteSent: false,
      hasVotingError: false,
      hasInvalidEmail: false,
      didNotAgree: false,
      hasInvalidPhone: false,
      captchaSiteKey,
      viewTerms: false
    }
  },

  computed: {
    rounds() {
      return this.$store.state.rounds
    },

    allowSuggestions() {
      return this.$store.state.allowSuggestions
    },

    selectedNominees() {
      return this.$store.state.selected.filter(selected => {
        return typeof selected.nomineeId !== 'undefined'
      })
    },

    selectedSuggestions() {
      const selected = this.$store.state.selected.filter(selected => {
        return typeof selected.suggestionName !== 'undefined'
      })

      return selected.map(({ suggestionName, suggestionStation, ...obj }) => ({
        ...obj,
        name: suggestionName,
        secondary_name: suggestionStation || '-'
      }))
    },

    selection() {
      return this.$store.getters.selection
    },

    anySelected() {
      return this.selection.some(({ nominee, suggestion }) => nominee || suggestion)
    }
  },

  methods: {
    isValidEmail() {
      return this.$refs.emailInput.validity.valid
    },

    isValidPhone() {
      return this.$refs.phoneInput ? this.$refs.phoneInput.validity.valid : false
    },

    isIncomplete() {
      return (
        this.agreed === false ||
        this.isValidEmail() === false ||
        (this.galaOptIn === true && this.isValidPhone() === false)
      )
    },

    validate() {
      return this.isIncomplete() === false
    },

    submit(captchaHash) {
      if (this.isIncomplete()) {
        this.hasInvalidEmail = this.isValidEmail() === false
        this.didNotAgree = this.agreed === false
        this.hasInvalidPhone = this.isValidPhone() === false
        return
      }

      const round = this.rounds[0]
      const data = {
        captchaHash,
        email: this.email,
        roundId: round.id,
        extraFields: {
          keepUpToDate: this.keepUpToDate,
          galaOptIn: this.galaOptIn,
          phone: this.phone
        }
      }

      if (this.allowSuggestions) {
        data.suggestions = this.selectedSuggestions
      }

      if (this.selectedNominees.length > 0) {
        data.votes = this.selectedNominees
      }
      this.sending = true
      post('voting/vote', {
        data: JSON.stringify(data)
      })
        .then(response => {
          if (response.ok) {
            response.json().then(({ data }) => {
              if (data.saved) {
                this.voteSent = true
                this.$store.dispatch('clearSelected')
              } else {
                this.hasVotingError = true
              }
            })
          } else {
            this.hasVotingError = true
          }

          this.sending = false
        })
        .catch(() => {
          this.hasVotingError = true
          this.sending = false
        })
    },

    stylesForNominee(nominee) {
      return {
        backgroundImage: `url(${nominee.image})`
      }
    },

    urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Submit.vue